var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import idHelper from "@irati/utils/id";
import authentication from "@irati/auth";
import { PriceInput } from "@irati/ui/src/FormItem";
var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  .perkboxInput {\n    width: 100%;\n  }\n  .col-xs-12 {\n    padding: 0;\n  }\n"], ["\n  display: flex;\n  .perkboxInput {\n    width: 100%;\n  }\n  .col-xs-12 {\n    padding: 0;\n  }\n"])));
var TenantWalletTopUpAmount = /** @class */ (function (_super) {
    __extends(TenantWalletTopUpAmount, _super);
    function TenantWalletTopUpAmount() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TenantWalletTopUpAmount.prototype.render = function () {
        var currency = authentication.defaultUserCurrency();
        var _a = this.props, amount = _a.amount, updateAmount = _a.updateAmount;
        return (React.createElement(StyledDiv, null,
            React.createElement(PriceInput, { currency: currency, id: idHelper("TenantWalletTopUpAmount", this.props), label: "wallet.tenant.transfer.amount.label", min: "1.00", name: "TenantWalletTopUpAmount", onChange: updateAmount, step: "0.01", value: amount })));
    };
    return TenantWalletTopUpAmount;
}(Component));
export default TenantWalletTopUpAmount;
var templateObject_1;
